import script from "./ImageAttachment.vue?vue&type=script&setup=true&lang=ts"
export * from "./ImageAttachment.vue?vue&type=script&setup=true&lang=ts"

import "./ImageAttachment.vue?vue&type=style&index=0&id=2d603a92&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2d603a92"]])

export default __exports__